import { ArchivedAgendaPage } from "./ArchivedAgendaPage";

export default ArchivedAgendaPage;
